import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import { store } from "./store";
import { AppBootstrap } from "./ui/bootstrap";
import { readSlugFromPath, getDeviceId } from "./utils";

// The uploader is served under a per-site path segment
// (e.g. https://host/smith-jones). Mounting the router at that basename
// keeps the in-app routes ("/", "/gallery", "/download") relative
// while deep links and refreshes resolve correctly. At the bare root
// (local dev) the basename collapses to "/".
const slug = readSlugFromPath();
const basename = slug ? `/${slug}` : "/";

// Ensure a stable per-device id exists from the first visit (used by DJ
// requests for one-vote-per-device, and a foundation for future features).
getDeviceId();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <Provider store={store}>
        <AppBootstrap />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
